import axios from "@/lib/axios";
import { useQuery } from "@tanstack/vue-query";
import { watch } from "vue";
import { useStateStore } from "@/stores/state";
import { State } from "@/interfaces/state";
import { storeToRefs } from "pinia";

const getStates = async () => {
    const { data } = await axios.get<State[]>(`/api/status`);
    return data;
};

const useState = () => {
    const { data, isError, isLoading, refetch } = useQuery(
        ["states"],
        getStates
    );
    const { setStates, getState } = useStateStore();
    const {  states } = storeToRefs(useStateStore());

    watch(
        data,
        () => {
            if (data.value) {
                setStates(data.value);
            }
        }
    );

    return {
        isError,
        isLoading,
        data,
        refetch: () => {
            setStates([]);
            return refetch();

        },
        getState,
        states
    };
};

export default useState;
